import * as React from 'react';
import Typography from '@mui/material/Typography';
import { getConfigText, isEmpty } from "../utils";
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from "@mui/material/Grid";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CircleIcon from '@mui/icons-material/Circle';

export default function IntroSkillPage({ pageId }) {


    const skills = getConfigText(pageId, "vaardigheden");
    const cardSM = Math.floor(12 / skills.length);

    return (
        <React.Fragment>
            {/* <Typography variant="h5" gutterBottom>
                Leerdoelen en Oefeningen bij de vaardigheid “{getConfigText(pageId, "thematitel")}”
            </Typography> */}

            <Typography
                variant="h5"
                gutterBottom
            >
                {isEmpty(skills) ? "" : "Vaardigheden"}
            </Typography>

            <Grid
                container
                spacing={3}
                justifyContent="center"
                alignItems="stretch"
                mb={2}
            >
                {
                    skills.map((c, i) => (
                        <Grid key={"vaardigheden_" + i} item xs={12} sm={cardSM}>
                            <Card >
                                <CardContent>
                                    <FormatQuoteIcon />
                                    <Typography variant="body2">
                                        {c}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))
                }
            </Grid>

            <Typography
                variant="h5"
                gutterBottom
            >
                Leerdoelen
            </Typography>
            <Typography variant="body2" gutterBottom>
                {getConfigText(pageId, "leerdoelen_inleiding")}
            </Typography>

            <Typography variant="body2" gutterBottom component="div">
            <List>
                {getConfigText(pageId, "leerdoelen").map((c, i) => (
                    <ListItem key={"leerdoelen_" + i}>
                        <ListItemIcon >
                            <CircleIcon sx={{ fontSize: '0.7rem' }} />
                        </ListItemIcon>
                        {c}
                    </ListItem>
                ))}
            </List>
            </Typography>



        </React.Fragment>
    );
}
